// @mui
import { Container, Grid } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../../../routes/paths';
// hooks
import useSettings from '../../../../hooks/useSettings';
// components
import Page from '../../../../components/Page';
import HeaderBreadcrumbs from '../../../../components/HeaderBreadcrumbs';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores/store';
import useLocales from '../../../../hooks/useLocales';
import { EmployeeDetailTableRow } from '../EmployeeList';
import { useState, useEffect } from 'react';
import Loader from 'src/components/loader/Loader';
// ----------------------------------------------------------------------
export default observer(function EmployeeDetailHeader() {
  const { translate } = useLocales();
  const {
    EmployeeStore: { SelectedEmployeeDetail, clearSelectedEmployee, loadEmployeeDetail, ID },
  } = useStore();

  const [isLoading, setIsLoading] = useState(true); // Loading state

  useEffect(() => {
    if (ID) {
      setIsLoading(true);
      loadEmployeeDetail(ID).finally(() => setIsLoading(false)); // Ensure loading ends
    }
  }, [loadEmployeeDetail, ID]);

  const { themeStretch } = useSettings();

  // Handle case when no ID or data is available
  if (!ID) {
    return (
      <Page title={translate('Employee.DetailsTitle')}>
        <Container maxWidth={themeStretch ? false : 'lg'}>
          <HeaderBreadcrumbs
            heading={translate('Employee.EmployeeDetails')}
            links={[
              { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
              { name: `${translate('Employee.Employee')}`, href: PATH_DASHBOARD.Employee.list },
            ]}
          />
          <p>{translate('Employee.NoEmployeeSelected')}</p>
        </Container>
      </Page>
    );
  }

  return (
    <Page title={translate('Employee.DetailsTitle')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('Employee.EmployeeDetails')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            { name: `${translate('Employee.Employee')}`, href: PATH_DASHBOARD.Employee.list },
          ]}
        />
        {isLoading ? ( // Show loading state
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <Loader /> {/* Replace with Loader */}
          </Grid>
        ) : SelectedEmployeeDetail ? ( // Render details if available
          <Grid container>
            <EmployeeDetailTableRow
              row={SelectedEmployeeDetail}
              clearEmployee={clearSelectedEmployee}
            />
          </Grid>
        ) : (
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <p>{translate('Employee.NoDetailsFound')}</p>
          </Grid>
        )}
      </Container>
    </Page>
  );
});
